import { render, staticRenderFns } from "./ShiftAdd.vue?vue&type=template&id=b3d0b4ee&"
import script from "./ShiftAdd.vue?vue&type=script&lang=js&"
export * from "./ShiftAdd.vue?vue&type=script&lang=js&"
import style0 from "./ShiftAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports